import { compose, withHooks } from "enhancers"
import { Avatar } from "components"
import PropTypes from "prop-types"

const ImageUploadWithoutForm = (props) => (
  <Avatar {...props} variant="square" style={{ height: 120, width: 120 }} src={props.src} />
)

const enhancer = compose(
  withHooks((props, hooks) => {
    const { useEffect, useState } = hooks
    const { value, ...rest } = props

    const [image, setImage] = useState(value)

    const file = image
    const { url, filename } = file
    useEffect(() => {
      if (filename && url) {
        const loadFile = async () => {
          const blob = await fetch(url).then((r) => r.blob())
          const file = new File([blob], filename, { type: blob.type })
          setImage(file)
        }
        loadFile()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, filename])

    const src = file instanceof File ? URL.createObjectURL(file) : null

    return {
      ...rest,
      src,
    }
  }),
)

ImageUploadWithoutForm.propTypes = {
  src: PropTypes.any.isRequired,
}

export default enhancer(ImageUploadWithoutForm)
